import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle, useStatoInSolaLettura } from "../../../../layouts/PageHeaderExtra";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { format } from 'date-fns';
import { italianProvinces, sports } from "../../../../components/Util/enum";

export const AdminUserCoursesEdit = () => {

    const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ]

    const optionsPayment = [
        { value: "CASH", label: "Contanti" },
        { value: "CARD", label: "Carta di credito" },
        { value: "BANK_TRANSFER", label: "Bonifico" }
    ]

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [userBookingCourses] = await Promise.all([
                        apiClient.getUserBookingCourseById(token, id)
                    ]);
					setLoadingShowed(false);

                    if(userBookingCourses) {
                        const elementFormData = {
                            course_name: userBookingCourses.course_name,
                            sportType: userBookingCourses.sportType,
                            playerName: userBookingCourses.playerName,
                            juniorName: userBookingCourses.juniorName,
                            price: userBookingCourses.price+' €',
                            startDate: userBookingCourses.startDate ? format(new Date(userBookingCourses.startDate), 'dd/MM/yyyy') : '',
                            endDate: userBookingCourses.endDate ? format(new Date(userBookingCourses.endDate), 'dd/MM/yyyy') : '',
                            clubName: userBookingCourses.clubName
                        }

                        let status = null;
                        if(userBookingCourses.status === 'PAID') {
                            status = {
                                "label": "Pagato",
                                "class": "text-success"
                            };
                        } else if(userBookingCourses.status === 'UNPAID') {
                            status = {
                                "label": "Non pagato",
                                "class": "text-primary"
                            };
                        } else if(userBookingCourses.status === 'REFUNDED') {
                            status = {
                                "label": "Rimborsato",
                                "class": "text-warning"
                            };
                        } else if(userBookingCourses.status === 'CANCELLED') {
                            status = {
                                "label": "Annullato",
                                "class": "text-error"
                            };
                        }

                        elementFormData.id = userBookingCourses.id;
                        elementFormData.status = status;
                        elementFormData.originalStatus = userBookingCourses.status;

                        if(userBookingCourses.receiver) {
                            elementFormData.codice_fiscale = userBookingCourses.receiver.tax_code;
                            elementFormData.email = userBookingCourses.receiver.pec;
                            elementFormData.indirizzo = userBookingCourses.receiver.address;
                            elementFormData.cap = userBookingCourses.receiver.zip_code;
                            elementFormData.citta = userBookingCourses.receiver.city;
                            elementFormData.provincia = userBookingCourses.receiver.province;
                            if(userBookingCourses.receiver.type === 'consumer') {
                                elementFormData.tipo_cliente = 'privato';
                                elementFormData.nome = userBookingCourses.receiver.first_name;
                                elementFormData.cognome = userBookingCourses.receiver.last_name;
                            } else if(userBookingCourses.receiver.type === 'business') {
                                elementFormData.tipo_cliente = 'azienda';
                                elementFormData.ragione_sociale = userBookingCourses.receiver.denomination;
                                elementFormData.partita_iva = userBookingCourses.receiver.vat_number;
                                elementFormData.codice_destinatario = userBookingCourses.receiver.sdi_code;
                            }
                        }

                        if(userBookingCourses.status !== 'UNPAID') {
                            elementFormData.is_pagato = true;
                            if(userBookingCourses.payment_method) {
                                elementFormData.modalita_pagamento = userBookingCourses.payment_method;
                            }
                        } else {
                            elementFormData.is_pagato = false;
                        }

                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

    const [formData, setFormData] = useState({
        course_name: '',
        sportType: '',
        playerName: '',
        juniorName: '',
        price: '',
        status: '',
        startDate: '',
        endDate: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        clubName: ''
    });

    // Titolo della pagina = nome del corso acquistato, appena caricato.
    usePageTitle(formData?.course_name);

    // Stato in sola lettura accanto al titolo (da qui non si cambia)
    useStatoInSolaLettura(formData?.status?.label, formData?.originalStatus === 'PAID' ? 'attivo' : formData?.originalStatus === 'UNPAID' ? 'non-attivo' : 'bozza');

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const goBack = () => {
        window.history.back();
	};

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Dettagli del corso</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-lg-6">
                                    <Form.Label>Struttura</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="club_name	" value={formData.clubName } style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Abbonamento</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="course_name	" value={formData.course_name	} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Sport</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="sportType" value={sports.find(s => s.value === formData.sportType)?.label || formData.sportType} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Cliente</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="playerName" value={formData.playerName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Junior</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="juniorName" value={formData.juniorName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Data di inizio</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="startDate" value={formData.startDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Data di fine</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="endDate" value={formData.endDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Prezzo</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="price" value={formData.price} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Fatturazione</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                {/* Selezione Tipo Cliente */}
                                <Col md={12}>
                                    <Form.Label>Tipo Cliente</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="tipo_cliente"
                                        value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                        options={optionsFatturazione}
                                    />
                                </Col>
                            </Row>
                            {/* Azienda */}
                            {formData.tipo_cliente === 'azienda' && (
                                <Row className="mt-4">
                                    <Col lg={4}>
                                        <Form.Label>Ragione sociale</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="ragione_sociale"
                                            value={formData.ragione_sociale}
                                            onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Partita IVA</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="partita_iva"
                                            value={formData.partita_iva}
                                            onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="codice_destinatario"
                                            value={formData.codice_destinatario}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}
                            {/* Privato */}
                            {formData.tipo_cliente === 'privato' && (
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="nome"
                                            value={formData.nome}
                                            onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Cognome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="cognome"
                                            value={formData.cognome}
                                            onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}

                            {/* Campi comuni */}
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Codice Fiscale</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="codice_fiscale"
                                        value={formData.codice_fiscale}
                                        onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Email PEC / Email</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Indirizzo</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="indirizzo"
                                        value={formData.indirizzo}
                                        onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>CAP</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="cap"
                                        value={formData.cap}
                                        onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>Città</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="citta"
                                        value={formData.citta}
                                        onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Provincia</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="provincia"
                                        value={italianProvinces.find(option => option.value === formData.provincia)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                        options={italianProvinces}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Nazione</Form.Label>
                                    <Form.Control
                                        required
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="nazione"
                                        value="Italia"
                                        onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Pagamento</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col md={6}>
                                    <Form.Label>Pagato</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="is_pagato"
                                        value={optionsBoolean.find(option => option.value === formData.is_pagato)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "is_pagato")} 
                                        options={optionsBoolean}
                                    />
                                </Col>
                                {formData.is_pagato && ( <Col md={6}>
                                    <Form.Label>Modalità di pagamento</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="modalita_pagamento"
                                        value={optionsPayment.find(option => option.value === formData.modalita_pagamento)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
                                        options={optionsPayment}
                                    />
                                </Col> )}
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <button type="button" className="btn btn-dark light" onClick={() => goBack()}>Indietro</button>
                    </div>
                </div>
            </Row>
		</>
	)

}
export default AdminUserCoursesEdit;